<app-account-page-wrapper title="Create your account" subtitle="Start verifying deceased consumers and protecting your revenue.">
  <form novalidate (submit)="onSubmit($event)">
    <div class="form-row">
      <div class="form-group">
        <label for="firstName">First name</label>
        <input id="firstName" type="text" class="form-control" placeholder="Jane" [formField]="registerForm.firstName" />
        @if (registerForm.firstName().touched() && registerForm.firstName().invalid()) {
          <span class="field-error">{{ registerForm.firstName().errors()[0].message }}</span>
        }
      </div>

      <div class="form-group">
        <label for="lastName">Last name</label>
        <input id="lastName" type="text" class="form-control" placeholder="Doe" [formField]="registerForm.lastName" />
        @if (registerForm.lastName().touched() && registerForm.lastName().invalid()) {
          <span class="field-error">{{ registerForm.lastName().errors()[0].message }}</span>
        }
      </div>
    </div>

    <div class="form-group">
      <label for="email">Work email</label>
      <input id="email" type="email" class="form-control" placeholder="you@company.com" [formField]="registerForm.email" />
      @if (registerForm.email().touched() && registerForm.email().invalid()) {
        <span class="field-error">{{ registerForm.email().errors()[0].message }}</span>
      }
    </div>

    <div class="form-group">
      <label for="phone">Phone <span class="field-optional">(optional)</span></label>
      <input id="phone" type="tel" class="form-control" placeholder="+11234567890" [formField]="registerForm.phone" />
      @if (registerForm.phone().touched() && registerForm.phone().invalid()) {
        <span class="field-error">{{ registerForm.phone().errors()[0].message }}</span>
      }
    </div>

    <div class="form-group">
      <label for="password">Password</label>
      <app-password-input id="password" placeholder="Create a password" [formField]="registerForm.password" />
      @if (registerForm.password().touched() && registerForm.password().invalid()) {
        <span class="field-error">{{ registerForm.password().errors()[0].message }}</span>
      }
    </div>

    <div class="form-group">
      <label for="confirmPassword">Confirm password</label>
      <app-password-input
        id="confirmPassword"
        placeholder="Confirm your password"
        [formField]="registerForm.confirmPassword"
      />
      @if (registerForm.confirmPassword().touched() && registerForm.confirmPassword().invalid()) {
        <span class="field-error">{{ registerForm.confirmPassword().errors()[0].message }}</span>
      }
    </div>

    <div class="form-group consent-group">
      <label class="consent" for="acceptTerms">
        <input
          id="acceptTerms"
          type="checkbox"
          [checked]="model().acceptTerms"
          (change)="toggleTerms($event)"
        />
        <span class="consent-text">
          I agree to the
          <a [routerLink]="[routes.terms.url]" target="_blank" rel="noopener">Terms of Service</a>
          and
          <a [routerLink]="[routes.privacy.url]" target="_blank" rel="noopener">Privacy Policy</a>,
          and I confirm I will use this service for a lawful, permissible purpose.
        </span>
      </label>
      @if (termsTouched() && !model().acceptTerms) {
        <span class="field-error">Please accept the Terms of Service and Privacy Policy to continue.</span>
      }
    </div>

    <button
      type="submit"
      class="btn btn-primary btn-block"
      [disabled]="registerForm().submitting() || !model().acceptTerms"
    >
      @if (registerForm().submitting()) {
        <span class="btn-spinner" aria-hidden="true"></span>
        Creating account...
      } @else {
        Create account
      }
    </button>
  </form>

  <p class="form-note">Already have an account? <a [routerLink]="[routes.accountLogin.url]">Sign in</a></p>
</app-account-page-wrapper>
